import React, { useState } from "react";
import {
  Table,
  Card,
  Typography,
  Row,
  Col,
  DatePicker,
  TableProps,
  Button,
  Spin,
} from "antd";
import NewDashboardSchemeModal from "./NewDashBoardSchemeModal";
import { useSelector } from "react-redux";

const { Title } = Typography;

interface DataType {
  key: string;
  month: string;
  "0-30": number;
  "31-60": number;
  "61-90": number;
  _91_120: number;
  above120: number;
  above90: number; // This will be computed dynamically
  inProgress: number;
  total: number;
}

const columnsDeductionDetails: any = [
  {
    title: "",
    dataIndex: "type",
    key: "type",
    align: "center",
  },
  {
    title: "Billed Amount",
    dataIndex: "billedAmount",
    key: "billedAmount",
    align: "center",
  },
  {
    title: "Cashless Approved",
    dataIndex: "cashlessApproved",
    key: "cashlessApproved",
    align: "center",
  },
  {
    title: "Difference",
    dataIndex: "difference",
    key: "difference",
    align: "center",
  },
  {
    title: "Patient Payable",
    dataIndex: "patientPayable",
    key: "patientPayable",
    align: "center",
  },
  {
    title: "TPA Discount",
    dataIndex: "tpaDiscount",
    key: "tpaDiscount",
    align: "center",
  },
  {
    title: "Gross Settled",
    dataIndex: "grossSettled",
    key: "grossSettled",
    align: "center",
  },
];

const columnsCoPayDeduction: any = [
  {
    title: "",
    dataIndex: "type",
    key: "type",
    align: "center",
  },
  {
    title: "Co-pay Deducted",
    dataIndex: "coPayDeducted",
    key: "coPayDeducted",
    align: "center",
  },
  {
    title: "NME Deduction",
    dataIndex: "nmeDeduction",
    key: "nmeDeduction",
    align: "center",
  },
  {
    title: "Patient Payable",
    dataIndex: "patientPayable",
    key: "patientPayable",
    align: "center",
  },
];

const columnsMonthOnMonth: any = [
  {
    title: "",
    dataIndex: "months",
    children: [
      { title: "month", dataIndex: "month", key: "month" },
      { title: "year", dataIndex: "year", key: "year" },
    ],
    key: "months",
    align: "center",
  },
  {
    title: "Total (Pending + Settled)",
    children: [
      {
        title: "Count",
        dataIndex: "totalCount",
        key: "totalCount",
        align: "center",
      },
      {
        title: "HSP Bill Amount",
        dataIndex: "totalHspBillAmount",
        key: "totalHspBillAmount",
        align: "center",
      },
      {
        title: "Insurance Payable Amount",
        dataIndex: "totalInsurancePayableAmount",
        key: "totalInsurancePayableAmount",
        align: "center",
      },
    ],
  },
  {
    title: "Settled",
    children: [
      {
        title: "Count",
        dataIndex: "settledCount",
        key: "settledCount",
        align: "center",
      },
      {
        title: "HSP Bill Amount",
        dataIndex: "settledHspBillAmount",
        key: "settledHspBillAmount",
        align: "center",
      },
      {
        title: "Insurance Payable Amount",
        dataIndex: "settledInsurancePayableAmount",
        key: "settledInsurancePayableAmount",
        align: "center",
      },
      {
        title: "Gross Settled",
        dataIndex: "settledGrossSettled",
        key: "settledGrossSettled",
        align: "center",
      },
    ],
  },
  {
    title: "Pending",
    children: [
      {
        title: "Count",
        dataIndex: "pendingCount",
        key: "pendingCount",
        align: "center",
      },
      {
        title: "HSP Bill Amount",
        dataIndex: "pendingHspBillAmount",
        key: "pendingHspBillAmount",
        align: "center",
      },
      {
        title: "Insurance Payable Amount",
        dataIndex: "pendingInsurancePayableAmount",
        key: "pendingInsurancePayableAmount",
        align: "center",
      },
    ],
  },
];

const { RangePicker } = DatePicker;

interface NewDashboardProps {
  businessDateRange: any;
  setBusinessDateRange: any;
  setMonthOnMonthDateRange: any;
  monthOnMonthDateRange: any;
  setSchemeId: any;
  schemeId: any;
  setVisitType: any;
  amtPercent: any;
  setAmtPercent: any;
  onPayerNameClick: any;
  onIntervalClick: any;
  onStatusClick: any;
  setDocumentDownload: any;
  setSelectedScheme: any;
  selectedScheme: any;
  downloadDocument: any;
  handleDownload: any;
  setHandleDownloadButton: any;
  handleDownloadButton: any;
  downloadLoading: boolean;
}
const Dashboard: React.FC<NewDashboardProps> = ({
  businessDateRange,
  setBusinessDateRange,
  setMonthOnMonthDateRange,
  monthOnMonthDateRange,
  schemeId,
  setSchemeId,
  setVisitType,
  setAmtPercent,
  amtPercent,
  onPayerNameClick,
  onIntervalClick,
  onStatusClick,
  setDocumentDownload,
  setSelectedScheme,
  selectedScheme,
  downloadDocument,
  handleDownload,
  setHandleDownloadButton,
  handleDownloadButton,
  downloadLoading,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [activeTab, setActiveTab] = useState("TPA/IC");
  const [expanded, setExpanded] = useState(false);
  const [expandedForProcess, setExpandedForProcess] = useState(false);
  const [expandedForMonthOnMonth, setExpandedForMonthOnMonth] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState<any>("");
  const [selectedInterval, setSelectedInterval] = useState<any>("");
  const [selectedMonth, setSelectedMonth] = useState<any>("");
  const [settled, setSettled] = useState<any>("");

  const tabs = [
    { name: "TPA/IC", id: -1, visitId: 1 },
    { name: "CGHS(IP)", id: 1, visitId: 1 },
    { name: "CGHS(OP)", id: 1, visitId: 2 },
    { name: "ECHS(IP)", id: 2, visitId: 1 },
    { name: "ECHS(OP)", id: 2, visitId: 2 },
  ];
  const [selectedPayer, setSelectedPayer] = useState(null);
  const [visibleDeductions, setVisibleDeductions] = useState(true);
  const {
    businessSnapshot,
    DSOData,
    deductionDetails,
    deduction,
    deductionsData,
    monthOnMonthClaimStatusData,
    dashboardCghsStatusTableSubResponseList,
    agingProcessData,
    schemeTableData,
    agingSettledData,
    BSSApproved,
    BSSGrossSettled,
    BSSinProcess,
    loading,
    error,
    isFetchingSchemeTableData,
    isFetchingMonthOnMonthClaimStatus,
    isFetchingCghsStatusTable,
    isFetchingBSS,
    isFetchingDSO,
  } = useSelector((state: any) => state.dashboard);
  const handlePayerClick = (record: any) => {
    onPayerNameClick(record?.payerName);
    setSelectedScheme(record?.payerName);
    setHandleDownloadButton({
      scheme: true,
      status: false,
      interval: false,
    });
    setSelectedPayer(record);
    setIsModalVisible(true);
  };

  const dataForSettled = expanded
    ? agingSettledData
    : agingSettledData.slice(0, 6);
  const dataForProcess = expandedForProcess
    ? agingProcessData
    : agingProcessData.slice(0, 6);
  const dataForMonthOnMonth = expandedForMonthOnMonth
    ? monthOnMonthClaimStatusData
    : monthOnMonthClaimStatusData.slice(0, 6);

  const downloadDoc = () => {
    if (
      handleDownloadButton.scheme &&
      !handleDownloadButton.interval &&
      !handleDownloadButton.status
    ) {
      if (selectedScheme) {
        handleDownload(selectedScheme);
      }
    } else if (
      !handleDownloadButton.scheme &&
      !handleDownloadButton.interval &&
      handleDownloadButton.status
    ) {
      if (selectedStatus) {
        handleDownload(selectedStatus);
      }
    } else {
      if (selectedInterval) {
        handleDownload(selectedMonth, selectedInterval, settled);
      }
    }
  };

  const handleCategoryClick = (record: any) => {
    onPayerNameClick(record?.category);
    setSelectedScheme(record?.category);
    setSelectedPayer(record);
    setIsModalVisible(true);
    setHandleDownloadButton({
      scheme: true,
      status: false,
      interval: false,
    });
  };

  const columnsCGHS = [
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text: any, record: any) => (
        <span
          style={{
            color: "#004C8F", // Removed extra #
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={() => handleStatusClick(record?.status)}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Count",
      dataIndex: "count",
      key: "count",
    },
    {
      title: "Billed Amount",
      dataIndex: "billedAmount",
      key: "billedAmount",
    },
    {
      title: "CPD Approved",
      dataIndex: "cpdApprovedAmount",
      key: "cpdApprovedAmount",
    },
    {
      title: "Settled",
      dataIndex: "settled",
      key: "settled",
    },
  ];

  const handleIntervalClick = (
    settled: string,
    record: any,
    interval: string
  ) => {
    onIntervalClick(interval, record?.month, settled);
    // setSelectedPayer(record);
    setIsModalVisible(true);
    setSelectedInterval(interval);
    setSettled(settled);
    setSelectedMonth(record?.month);
    setHandleDownloadButton({
      scheme: false,
      status: false,
      interval: true,
    });
  };

  const handleStatusClick = (status: any) => {
    onStatusClick(status);
    setSelectedStatus(status);
    // setSelectedPayer(record);
    setIsModalVisible(true);
    setHandleDownloadButton({
      scheme: false,
      status: true,
      interval: false,
    });
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setSelectedPayer(null);
  };

  const columnsAgingSettled: TableProps<DataType>["columns"] = [
    {
      title: "",
      children: [
        {
          title: "Months",
          dataIndex: "month",
          key: "month",
          align: "center",
          width: "3%",
        },
      ],
      fixed: "left",
    },
    {
      title: "0-30",
      children: [
        {
          title: "Count",
          width: "3%",
          dataIndex: "_0_30",
          key: "_0_30",
          align: "center",
          render: (text: any, record: any) => (
            <span
              style={{
                color: "#004C8F", // Removed extra #
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => handleIntervalClick("yes", record, "0_30")}
            >
              {text}
            </span>
          ),
        },
      ],
    },
    {
      title: "31-60",
      children: [
        {
          title: "Count",
          dataIndex: "_31_60",
          width: "3%",
          key: "_31_60",
          align: "center",
          render: (text: any, record: any) => (
            <span
              style={{
                color: "#004C8F",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => handleIntervalClick("yes", record, "31_60")}
            >
              {text}
            </span>
          ),
        },
      ],
    },
    {
      title: "61-90",
      children: [
        {
          title: "Count",
          dataIndex: "_61_90",
          width: "3%",
          key: "_61_90",
          align: "center",
          render: (text: any, record: any) => (
            <span
              style={{
                color: "#004C8F",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => handleIntervalClick("yes", record, "61_90")}
            >
              {text}
            </span>
          ),
        },
      ],
    },
    {
      title: "90-120",
      children: [
        {
          title: "Count",
          dataIndex: "_91_120",
          key: "_91_120",
          align: "center",
          render: (text: any, record: DataType) => (
            <span
              style={{
                color: "#004C8F",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => handleIntervalClick("yes", record, "91_120")}
            >
              {text}
            </span>
          ),
        },
      ],
    },
    {
      title: "above 120",
      children: [
        {
          title: "Count",
          dataIndex: "above120",
          key: "above120",
          align: "center",
          render: (text: any, record: DataType) => (
            <span
              style={{
                color: "#004C8F",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => handleIntervalClick("yes", record, "above120")}
            >
              {text}
            </span>
          ),
        },
      ],
    },
    {
      title: "Total",
      children: [
        {
          title: "count",
          align: "center",
          dataIndex: "total",
          width: "3%",
          key: "total",
        },
      ],
    },
  ];

  const columnsAgingProcess: TableProps<DataType>["columns"] = [
    {
      title: "",
      children: [
        {
          title: "Months",
          dataIndex: "month",
          key: "month",
          width: "3%",
          align: "center",
        },
      ],
      fixed: "left", // Fixed to the left
    },
    {
      title: "0-30",
      children: [
        {
          title: "Count",
          width: "3%",
          dataIndex: "_0_30",
          key: "_0_30",
          align: "center",
          render: (text: any, record: any) => (
            <span
              style={{
                color: "#004C8F",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => handleIntervalClick("no", record, "0_30")}
            >
              {text}
            </span>
          ),
        },
      ],
    },
    {
      title: "31-60",
      children: [
        {
          title: "Count",
          dataIndex: "_31_60",
          width: "3%",
          key: "_31_60",
          align: "center",
          render: (text: any, record: any) => (
            <span
              style={{
                color: "#004C8F",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => handleIntervalClick("no", record, "31_60")}
            >
              {text}
            </span>
          ),
        },
      ],
    },
    {
      title: "61-90",
      children: [
        {
          title: "Count",
          dataIndex: "_61_90",
          width: "3%",
          key: "_61_90",
          align: "center",
          render: (text: any, record: any) => (
            <span
              style={{
                color: "#004C8F",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => handleIntervalClick("no", record, "61_90")}
            >
              {text}
            </span>
          ),
        },
      ],
    },
    // {
    //   title: "91-120",
    //   children: [
    //     { title: "Count", dataIndex: "91-120", key: "91-120" },
    //   ],
    // },
    {
      title: "90_120",
      children: [
        {
          title: "Count",
          dataIndex: "_91_120",
          key: "_91_120",
          align: "center",
          render: (text: any, record: DataType) => (
            <span
              style={{
                color: "#004C8F",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => handleIntervalClick("no", record, "91_120")}
            >
              {text}
            </span>
          ),
        },
      ],
    },
    {
      title: "above 120",
      children: [
        {
          title: "Count",
          dataIndex: "above120",
          key: "above120",
          align: "center",
          render: (text: any, record: DataType) => (
            <span
              style={{
                color: "#004C8F",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => handleIntervalClick("no", record, "above120")}
            >
              {text}
            </span>
          ),
        },
      ],
    },
    // {
    //   title: "In Progress",
    //   // width:"18%",
    //   children: [
    //     {
    //       title: "count",
    //       dataIndex: "inProgress",
    //       key: "inProgress",
    //       align: "center",

    //     },
    //   ],
    // },
    {
      title: "Total",
      children: [
        {
          title: "count",
          align: "center",
          dataIndex: "total",
          width: "3%",
          key: "total",
        },
      ],
    },
  ];

  const columnsDSO: any = [
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      align: "center",
      render: (text: any, record: any) => (
        <span
          style={{
            color: "#004C8F",
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={() => handleCategoryClick(record)}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Business Done (Approved Amount)",
      dataIndex: "businessApprovedAmount",
      key: "businessApprovedAmount",
      align: "center",
    },
    {
      title: "Outstanding (Approved Amount)",
      dataIndex: "outstandingApprovedAmount",
      key: "outstandingApprovedAmount",
      align: "center",
    },
    { title: "Days", dataIndex: "days", align: "center", key: "days" },
    { title: "DSO", dataIndex: "dso", align: "center", key: "dso" },
  ];
  const columnForPayerName = (handlePayerClick: any) => [
    {
      title: <span style={{ color: "#004C8F" }}>hello</span>,

      children: [
        {
          title: "Payer Name",
          dataIndex: "payerName",
          key: "payerName",
          align: "center",
          render: (text: any, record: any) => (
            <span
              style={{
                color: "#004C8F",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => handlePayerClick(record)}
            >
              {text}
            </span>
          ),
        },
      ],
    },
  ];

  const columnsTotal = () => [
    {
      title: "Total (In Progress + Settled)",
      children: [
        {
          title: "Count",
          align: "center",
          dataIndex: "totalCount",
          key: "totalCount",
        },
        {
          title: "HSP Bill Amount",
          align: "center",
          dataIndex: "totalHspBillAmount",
          key: "totalHspBillAmount",
        },
        {
          title: "Approved Amount",
          dataIndex: "totalApprovedAmount",
          key: "totalApprovedAmount",
          align: "center",
        },
      ],
    },
  ];

  const columnsInProgress = () => [
    {
      title: "In Progress",
      children: [
        {
          title: "Count",
          align: "center",
          dataIndex: "inProgressCount",
          key: "inProgressCount",
        },
        {
          title: "HSP Bill Amount",
          align: "center",
          dataIndex: "inProgressHspBillAmount",
          key: "inProgressHspBillAmount",
        },
        {
          title: "Approved Amount",
          align: "center",
          dataIndex: "inProgressApprovedAmount",
          key: "inProgressApprovedAmount",
        },
      ],
    },
  ];

  const columnsSettled = () => [
    {
      title: "Settled",
      children: [
        {
          title: "Count",
          align: "center",
          dataIndex: "settledCount",
          key: "settledCount",
        },
        {
          title: "HSP Bill Amount",
          dataIndex: "settledHspBillAmount",
          align: "center",
          key: "settledHspBillAmount",
        },
        {
          title: "Gross Settled",
          align: "center",
          dataIndex: "settledGross",
          key: "settledGross",
        },
      ],
    },
  ];

  const handleVisibilityOfDeductionTable = (schemeName: string) => {
    if (schemeName === "TPA/IC") {
      setVisibleDeductions(true);
    } else {
      setVisibleDeductions(false);
    }
  };

  return (
    <div
      style={{ padding: "0px 10px", background: "" }}
      className="new-dashboard"
    >
      {/* Business Snapshot Section */}
      <Card
        style={{
          marginBottom: "24px",
          padding: "12px 10px",
          border: " 0.4px solid #d9d9d9",
          boxShadow: "0px -1px 4px 0px #00000040 inset",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            <Title
              style={{
                textTransform: "initial",
                marginBottom: "10px",
                fontSize: "1.3rem",
              }}
              level={4}
            >
              Business Snap Shot
            </Title>
            <RangePicker
              defaultValue={businessDateRange}
              style={{ width: 260 }}
              onChange={(dates) => {
                if (dates) {
                  setBusinessDateRange(dates);
                }
              }}
            />
          </div>

          <div style={{ padding: "0 0.5rem" }}>
            <div
              className="patient-details-screen"
              style={{
                display: "flex",
                alignItems: "center",
                // gap: "10px",
                border: "0.4px solid #d9d9d9",
                borderRadius: "10px",
                padding: "2px 0",
                flexWrap: "wrap",
                marginTop: "0rem",
                // boxShadow: "0px -1px 4px 0px #00000040 inset",
                marginBottom: "1.6rem",
                background: " #F2F9F9",
                width: "30vw",
              }}
            >
              <div
                className="items"
                style={{
                  padding: "5px 0px 0px 0px",
                  borderRight: "1px solid #d9d9d9",
                  width: "30%",
                }}
              >
                <p
                  style={{
                    marginBottom: "0.1rem",
                    fontSize: "1rem",
                    fontWeight: "600",
                    color: "#575757",
                    textAlign: "center",
                    textTransform: "initial",
                  }}
                >
                  Approved
                </p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "5px",
                    alignItems: "center",
                  }}
                >
                  <p
                    style={{
                      fontWeight: "700",
                      fontSize: "1.3rem",
                      minHeight: "1rem",
                      color: "#004C8F",
                      textAlign: "center",
                      marginBottom: "0.4rem",
                    }}
                  >
                    {BSSApproved}
                  </p>
                  <span
                    style={{
                      fontWeight: "700",
                      fontSize: "0.7rem",
                      minHeight: "1rem",
                      color: "#004C8F",
                      textAlign: "center",
                    }}
                  >
                    Lakhs
                  </span>
                </div>
              </div>

              <div
                className="items"
                style={{
                  padding: "5px 0px 0px 0px",
                  borderRight: "1px solid #d9d9d9",
                  width: "32%",
                }}
              >
                <p
                  style={{
                    marginBottom: "0.1rem",
                    fontSize: "1rem",
                    fontWeight: "600",
                    color: "#575757",
                    textAlign: "center",
                    textTransform: "initial",
                  }}
                >
                  Gross Settled
                </p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "5px",
                    alignItems: "center",
                  }}
                >
                  <p
                    style={{
                      fontWeight: "700",
                      fontSize: "1.3rem",
                      minHeight: "1rem",
                      color: "#004C8F",
                      textAlign: "center",
                      marginBottom: "0.4rem",
                    }}
                  >
                    {BSSGrossSettled}
                  </p>
                  <span
                    style={{
                      fontWeight: "700",
                      fontSize: "0.7rem",
                      minHeight: "1rem",
                      color: "#004C8F",
                      textAlign: "center",
                    }}
                  >
                    Lakhs
                  </span>
                </div>
              </div>

              <div
                className="items"
                style={{
                  padding: "5px 0px 0px 0px",

                  width: "38%",
                }}
              >
                <p
                  style={{
                    marginBottom: "0.1rem",
                    fontSize: "1rem",
                    fontWeight: "600",
                    color: "#575757",
                    textAlign: "center",
                    textTransform: "initial",
                  }}
                >
                  In Process
                </p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "5px",
                    alignItems: "center",
                  }}
                >
                  <p
                    style={{
                      fontWeight: "700",
                      fontSize: "1.3rem",
                      minHeight: "1rem",
                      color: "#004C8F",
                      textAlign: "center",
                      marginBottom: "0.4rem",
                    }}
                  >
                    {BSSinProcess}
                  </p>
                  <span
                    style={{
                      fontWeight: "700",
                      fontSize: "0.7rem",
                      minHeight: "1rem",
                      color: "#004C8F",
                      textAlign: "center",
                      textTransform: "initial",
                    }}
                  >
                    Lakh (Approved)
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Spin spinning={isFetchingBSS}>
          <Card
            className="card-BSS"
            style={{
              border: " 0.4px solid #d9d9d9",
              boxShadow: "0px -1px 4px 0px #00000040 inset",
              padding: "10px 0px 15px 0px",
            }}
          >
            <Table
              dataSource={businessSnapshot}
              columns={columnForPayerName(handlePayerClick)}
              pagination={false}
              // loading={isFetchingBSS}
              bordered
            />
            <Table
              dataSource={businessSnapshot}
              columns={columnsTotal()}
              pagination={false}
              // loading={isFetchingBSS}
              bordered
            />
            <Table
              dataSource={businessSnapshot}
              columns={columnsInProgress()}
              pagination={false}
              // loading={isFetchingBSS}
              bordered
            />
            <Table
              dataSource={businessSnapshot}
              columns={columnsSettled()}
              // loading={isFetchingBSS}
              pagination={false}
              bordered
            />
          </Card>
        </Spin>
        {/* <p
          style={{
            margin: "10px 0px",
            textTransform: "initial",
            fontWeight: "normal",
            fontSize: "0.9rem",
          }}
        >
          • Difference in HSP Billed and Approved amount is toward Co-pay and 
          NME- (recovered from Patient) + Agreed Discount to IC/TPA.
        </p> */}
        <Card
          style={{
            border: " 0.4px solid #d9d9d9",
            boxShadow: "0px -1px 4px 0px #00000040 inset",
            padding: "10px 0px 15px 0px",
          }}
          // loading={isFetchingDSO}
        >
          <Title style={{ textTransform: "initial" }} level={4}>
            DSO (Days Sales Outstanding) :
          </Title>
          <Table
            dataSource={DSOData}
            columns={columnsDSO}
            pagination={false}
            bordered
            loading={isFetchingDSO}
          />
        </Card>
      </Card>

      {/* DSO Section */}

      {/* Month on Month Claims Status Section */}
      <div
        style={{
          padding: "0px",
          borderRadius: "8px",
          border: "0.4px solid #d9d9d9",
          boxShadow: "0px -1px 4px 0px #00000040 inset",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#F2F9F9",
            padding: "8px 20px",
            border: "1px solid #A6A6A6",
            borderTopRightRadius: "8px",
            borderTopLeftRadius: "8px",
          }}
        >
          {/* Spacer to push the tabs to the center */}
          <div style={{ flex: 1 }}></div>

          {/* Tabs Section */}
          <div
            style={{
              display: "flex",
              gap: "5px",
              background: "#fff",
              borderRadius: "30px",
              padding: "5px 10px",
              border: "2px solid #D9D9D9",
              flexShrink: 0, // Prevent shrinking
            }}
          >
            {tabs?.map((tab) => (
              <div
                key={tab.id}
                onClick={() => {
                  setActiveTab(tab.name);
                  setSchemeId(tab.id); // Update schemeId when tab is clicked
                  setVisitType(tab.visitId);
                  handleVisibilityOfDeductionTable(tab.name);
                }}
                style={{
                  backgroundColor:
                    activeTab === tab.name ? "#004C8F" : "transparent",
                  borderRadius: "30px",
                  boxShadow:
                    activeTab === tab.name
                      ? "0px -1px 4px 0px #00000040 inset"
                      : "none",
                  padding: "5px 12px",
                  color: activeTab === tab.name ? "#fff" : "#000",
                  cursor: "pointer",
                }}
              >
                {tab.name}
              </div>
            ))}
          </div>

          {/* RangePicker */}
          <div style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
            <RangePicker
              defaultValue={monthOnMonthDateRange}
              style={{ width: 260 }}
              onChange={(dates) => {
                if (dates) {
                  setMonthOnMonthDateRange(dates);
                }
              }}
            />
          </div>
        </div>

        <div style={{ padding: "12px 23px" }}>
          <Title
            style={{
              textTransform: "initial",
              marginBottom: "10px",
              fontSize: "1.3rem",
            }}
            level={4}
          >
            Month On Month Claims Status :
            <span style={{ color: "#004C8F", marginLeft: "10px" }}>
              {activeTab}
            </span>
          </Title>
          <div style={{ marginTop: "16px", marginBottom: "16px" }}>
            {activeTab == "TPA/IC" ||
            activeTab == "ECHS(IP)" ||
            activeTab == "ECHS(OP)" ? (
              <>
                <Table
                  dataSource={dataForMonthOnMonth}
                  columns={columnsMonthOnMonth}
                  pagination={false}
                  loading={isFetchingMonthOnMonthClaimStatus}
                  bordered
                />
                <div style={{ textAlign: "right", marginTop: "10px" }}>
                  <Button
                    type="link"
                    onClick={() =>
                      setExpandedForMonthOnMonth(!expandedForMonthOnMonth)
                    }
                  >
                    {expandedForMonthOnMonth ? "See Less" : "See More"}
                  </Button>
                </div>
              </>
            ) : (
              <Table
                dataSource={dashboardCghsStatusTableSubResponseList}
                columns={columnsCGHS}
                pagination={false}
                loading={isFetchingCghsStatusTable}
                bordered
              />
            )}
          </div>
          {/* <p
            style={{
              marginTop: "16px",
              display: "block",
              textTransform: "initial",
            }}
          >
            * Deductions 4 Lakhs (Explained ahead), 1 pending case of July,
            settled on 12th Dec.
          </p> */}
        </div>
      </div>

      {/* Aging Section */}
      <Card
        style={{
          textTransform: "initial",
          border: " 0.4px solid #d9d9d9",
          boxShadow: "0px -1px 4px 0px #00000040 inset",
          padding: "10px 0px 15px 0px",
        }}
      >
        <Row justify="space-between">
          <Col>
            <Title
              style={{
                textTransform: "initial",
                marginBottom: "10px",
                fontSize: "1.3rem",
              }}
              level={4}
            >
              Aging :
              <span style={{ color: "#004C8F", marginLeft: "10px" }}>
                {activeTab}
              </span>
            </Title>
          </Col>
          <Col></Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Card
              style={{
                border: " 0.4px solid #d9d9d9",
                boxShadow: "0px -1px 4px 0px #00000040 inset",
                padding: "10px 0px 15px 0px",
              }}
            >
              <p
                style={{
                  marginBottom: "12px",
                  marginLeft: "15px",
                  textTransform: "initial",
                  color: "#575757",
                  fontWeight: "600",
                  fontSize: "15px",
                }}
              >
                Aging - Process
              </p>
              <Table
                dataSource={dataForProcess}
                columns={columnsAgingProcess}
                pagination={false}
                loading={isFetchingCghsStatusTable}
                style={{ textTransform: "initial" }}
                bordered
                rowKey="month"
              />
              <div style={{ textAlign: "right", marginTop: "10px" }}>
                <Button
                  type="link"
                  onClick={() => setExpandedForProcess(!expandedForProcess)}
                >
                  {expandedForProcess ? "See Less" : "See More"}
                </Button>
              </div>
            </Card>
            {/* <p
              style={{
                margin: "10px 0px",
                textTransform: "initial",
                fontWeight: "normal",
                fontSize: "0.9rem",
                marginTop: "25px",
              }}
            >
              • 3 Cases of FGHI, 4 of Health INDIA, 3 Medi-assist,  1 each of MD
              India, NIVA,  Paramount. Under regular follow Up.
            </p> */}
          </Col>
          <Col span={12}>
            <Card
              style={{
                border: " 0.4px solid #d9d9d9",
                boxShadow: "0px -1px 4px 0px #00000040 inset",
                padding: "10px 0px 15px 0px",
              }}
            >
              <p
                style={{
                  marginBottom: "12px",
                  marginLeft: "15px",
                  textTransform: "initial",
                  color: "#575757",
                  fontWeight: "600",
                  fontSize: "15px",
                }}
              >
                Aging - Settlement
              </p>

              <Table
                dataSource={dataForSettled}
                columns={columnsAgingSettled}
                pagination={false}
                loading={isFetchingCghsStatusTable}
                bordered
                rowKey="month"
              />
              <div style={{ textAlign: "right", marginTop: "10px" }}>
                <Button type="link" onClick={() => setExpanded(!expanded)}>
                  {expanded ? "See Less" : "See More"}
                </Button>
              </div>
            </Card>
            {/* <p
              style={{
                margin: "10px 0px",
                textTransform: "initial",
                fontWeight: "normal",
                fontSize: "0.9rem",
                marginLeft: "20px",
                marginTop: "25px",
              }}
            >
              •73% Cases settled in less than 30 Days.
            </p> */}
          </Col>
        </Row>
      </Card>
      {/* Deduction Details Section */}
      {visibleDeductions && (
        <Card
          style={{
            textTransform: "initial",
            border: "0.4px solid #d9d9d9",
            boxShadow: "0px -1px 4px 0px #00000040 inset",
            padding: "10px 0px 15px 0px",
          }}
        >
          <Col
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <Title
              style={{
                textTransform: "initial",
                marginBottom: "10px",
                fontSize: "1.3rem",
              }}
              level={4}
            >
              Deduction Details :
              <span style={{ color: "#004C8F", marginLeft: "10px" }}>
                {activeTab}
              </span>
            </Title>
            {/* <div
              style={{
                fontSize: "13px",

                display: "flex",
                gap: "5px",
                background: "#fff",
                borderRadius: "30px",
                padding: "5px 10px",
                border: "2px solid #D9D9D9",
                flexShrink: 0, // Prevent shrinking
              }}
            >
              <div
                // key={tab.id}
                onClick={() => {
                  setAmtPercent("count");
                }}
                style={{
                  backgroundColor:
                    amtPercent === "count" ? "#004C8F" : "transparent",
                  borderRadius: "30px",
                  boxShadow:
                    amtPercent === "count"
                      ? "0px -1px 4px 0px #00000040 inset"
                      : "none",
                  padding: "5px 12px",
                  color: amtPercent === "count" ? "#fff" : "#000",
                  cursor: "pointer",
                  textTransform: "initial",
                }}
              >
                Amount
              </div>
              <div
                // key={tab.id}
                onClick={() => {
                  setAmtPercent("percentage");
                }}
                style={{
                  backgroundColor:
                    amtPercent === "percentage" ? "#004C8F" : "transparent",
                  borderRadius: "30px",
                  boxShadow:
                    amtPercent === "percentage"
                      ? "0px -1px 4px 0px #00000040 inset"
                      : "none",
                  padding: "5px 12px",
                  color: amtPercent === "percentage" ? "#fff" : "#000",
                  cursor: "pointer",
                  textTransform: "initial",
                }}
              >
                Percentage
              </div>
            </div> */}
          </Col>

          <Table
            dataSource={deductionDetails}
            columns={columnsDeductionDetails}
            pagination={false}
            loading={isFetchingCghsStatusTable}
            bordered
          />

          <Row
            gutter={16}
            style={{
              marginTop: "40px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Col span={12}>
              <Table
                dataSource={deduction}
                columns={columnsCoPayDeduction}
                pagination={false}
                loading={isFetchingCghsStatusTable}
                bordered
              />

              {/* <Card
              bordered={false}
              style={{ background: "#f6f6f6", marginTop: "10%" }}
            >
              <p
                style={{
                  textTransform: "initial",
                  fontSize: "1rem",
                }}
              >
                • Short payment (1.6 lakhs) is less than 0.5% of total Business.
                <p
                  style={{
                    fontSize: "0.8rem",
                    textTransform: "initial",
                    margin: "0px",
                    fontWeight: "bold",
                    marginTop: "10px",
                  }}
                >
                  Under follow-up.
                </p>
                <p
                  style={{
                    fontSize: "0.8rem",
                    textTransform: "initial",
                    margin: "0px",
                  }}
                >
                  Market Practice is to settle short payment against deposit.
                </p>
              </p>
            </Card> */}
            </Col>
          </Row>
        </Card>
      )}
      <NewDashboardSchemeModal
        visible={isModalVisible}
        handleClose={handleModalClose}
        schemeTableData={schemeTableData}
        isLoading={isFetchingSchemeTableData}
        downloadDoc={downloadDoc}
        downloadLoading={downloadLoading}
        // payerName={}
      />
    </div>
  );
};

export default Dashboard;